export default "__VITE_ASSET__Ccdc6b$T__"